import React from 'react';
import { AMIAlert } from '../../ui-components/UiComponents';
import { useAppSelector } from '../../app/hooks';
import { appDataSelector, PidAdvisoryKey } from '../../features/appDataSlice';
import { isBannerActive } from '../../utilities/ContentRetrieverUtilities';

// Copy comes only from Content Management; nothing is shown when the entry is missing (FR-008).
const PidAdvisory: React.FC<{entryKey: PidAdvisoryKey, show: boolean, className?: string}> = ({entryKey, show, className}) => {

  const { pidAdvisory } = useAppSelector(appDataSelector);
  const entry = pidAdvisory?.entries?.[entryKey];

  if (!show || !entry || !isBannerActive(entry)) return null;

  return (
    <AMIAlert
      variant={entry.config.announcementType}
      style={{marginBottom: "24px"}}
      className={className}
    >
      <p><strong>{entry.title}</strong></p>
      <div className="faq-content" dangerouslySetInnerHTML={{__html: entry.content}}></div>
    </AMIAlert>
  )
}

export default PidAdvisory;
